var maintainSessionTimerThread;
// default of 5 however it is reset in SetAppPath
var _PingInterval = 5;
function startMaintainSessionTimerThread(targetViewId) {
  stopMaintainSessionTimerThread(targetViewId);
  var maintainSession = function() {
    sendPingRequest(null, targetViewId);
    startMaintainSessionTimerThread(targetViewId);
  };
  maintainSessionTimerThread = setTimeout(
    maintainSession,
    getMaintainSessionTimeout()
  );
}
// Get's the ping interval based on session timeout.
// This is set to the MaxPingInterval (typically 5 minutes) if session timeout exceeds this value.
// Otherwise the ping interval is set to session timeout.
function getMaintainSessionTimeout() {
  var maintainSessionTimeout = _PingInterval * 60 * 1000; //Ping every X minutes (based on _PingInterval).
  return maintainSessionTimeout;
}
function stopMaintainSessionTimerThread() {
  if (maintainSessionTimerThread) {
    clearTimeout(maintainSessionTimerThread);
    maintainSessionTimerThread = null;
  }
}
//Reset the session thread
function resetSessionThread(targetViewId) {
  stopMaintainSessionTimerThread();
  startMaintainSessionTimerThread(targetViewId);
}
function pingSession(targetViewId) {
  startMaintainSessionTimerThread(targetViewId);
  sendPingRequest(null, targetViewId);
}
//
// Sends a ping request - normally, it will send a ping request with remainactive as null.  If sent from the inactivity prompt,
//remainactive is true or false.
function sendPingRequest(remainactive, targetViewId) {
  var viewdoc = GetViewDocument(targetViewId);
  var form = viewdoc.forms[0];
  if (form) {
    var pinging =
      "<PING apid='" +
      form.getAttribute("apid") +
      "' monk='" +
      form.getAttribute("monk") +
      "'";
    if (remainactive != undefined) {
      //12/30/05 cpb
      if (remainactive == false) {
        //This is the case where the parent is the last window that made a request so attemp to close all children windows?
        while (_ChildWindowList.length > 0) {
          var win = _ChildWindowList.pop();
          if (win && !win.closed) {
            win.cleanCloseChild(targetViewId);
          }
        }
        var main = instance.opener;
        //this is the case where an info viewer is opened and it made the last request so the inactivity message is displayed for that
        //then we want to close it and display the log in screen for the parent instead.
        if (isChildWindow()) {
          SetInsideClose(targetViewId);
          instance.close(); //close the info viewer/modeless window
          main.sendPingRequest(remainactive, targetViewId); //the parent is now send the ping message
        }
      }
      //end 12/30/05
      pinging += " active='" + remainactive + "'";
    }
    if (isChildWindow() && document.location.search.length > 0) {
      // modal child window
      pinging += " modal='" + true + "'";
    } else {
      pinging += " modal='" + false + "'";
    }
    pinging += " />";
    if (
      form.getAttribute("apid") != undefined &&
      (form.getAttribute("apid").indexOf("LoginApplet") > -1 ||
        (form.getAttribute("apid").indexOf("InactivityMessageApplet") > -1 &&
          remainactive == null))
    ) {
      //don't send the ping request if it is login applet??
    } else {
      //Always send a ping request silently. Don't interrupt user focus with the wait message
      _SendSilently = true;
      sendCustomRequest(pinging, targetViewId);
    }
  }
}
